import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import i18nextHttpBackend from 'i18next-http-backend';

const SUPPORTED_LANGUAGES = ['de', 'it', 'fr'];

function initUserLanguage() {
    if (!localStorage.getItem('i18nextLng')) {
        const browserLang = navigator.language?.split('-')[0] ?? '';
        const lang = SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : 'fr';
        localStorage.setItem('i18nextLng', lang);
    }
}

function getDefaultsOptionsDetection() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupSessionStorage: 'i18nextLng',
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'],
  };
}

function getDefaultsOptionsBackend() {
  return {
    loadPath: '/api/translation/translationFront/{{lng}}',
  };
}

const configureI18n = () => {
    initUserLanguage();
    return i18n
        .use(i18nextHttpBackend)
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            fallbackLng: 'fr',
            load: 'languageOnly',
            supportedLngs: ['de', 'it', 'fr'],
            detection: getDefaultsOptionsDetection(),
            backend: getDefaultsOptionsBackend(),
            interpolation: {
                escapeValue: false,
            },
        });
};


export default configureI18n;
